import React, { useEffect, useState } from 'react';
import Alert from './Alert';
import { APP_PREFIX } from '../../config/appIdentifiers';

const NetworkStatusBanner = () => {
  const [isOnline, setIsOnline] = useState(true);
  const networkStatusEvent = `${APP_PREFIX}:network-status`;

  useEffect(() => {
    const markOnline = () => {
      setIsOnline(true);
    };

    const handleOnline = () => {
      markOnline();
    };

    const handleCustomNetworkStatus = (event) => {
      const nextState = event?.detail?.online;
      if (nextState === true) {
        markOnline();
        return;
      }
      if (nextState === false) {
        setIsOnline(false);
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener(networkStatusEvent, handleCustomNetworkStatus);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener(networkStatusEvent, handleCustomNetworkStatus);
    };
  }, [networkStatusEvent]);

  useEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }

    const className = 'network-offline-active';
    if (!isOnline) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }

    return () => {
      document.body.classList.remove(className);
    };
  }, [isOnline]);

  const isOffline = !isOnline;

  if (!isOffline) {
    return null;
  }

  return (
    <Alert
      type="critical"
      title="HORS-LIGNE - MODE DÉGRADÉ"
      message="Connexion perdue. Les actions sont sauvegardees localement puis synchronisees automatiquement au retour du reseau."
      persistent
    />
  );
};

export default NetworkStatusBanner;
